import Request from "../model/Request";
import Response from "../model/Response";
import {Config} from "../util/Config";
import PagedResponse from "../entities/PagedResponse";
import Pagination from "../entities/Pagination";
import { RestClient } from "../util/RestClient";
import ArticleWarehouse from "../entities/productOrder/article/ArticleWarehouse";
import TransferArticleRequest from "../model/transaction/TransferArticleRequest";

export module ArticleWarehouseService {
    export async function get(page: number = 1, pageSize: number = 15, filter?: string, agencyId?: string): Promise<Response<PagedResponse<ArticleWarehouse>>> {
        const url = Config.get("GET_ARTICLE_WAREHOUSES_URL", {page, pageSize, filter, agencyId});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const articleWarehousesData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (articleWarehousesData && paginationData) {
                const data = articleWarehousesData.map((t: any) => new ArticleWarehouse(
                    t.id,
                    t.agencyId,
                    t.name,
                    t.createdAt,
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ArticleWarehouse>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ArticleWarehouse>>(false, undefined, response.error, response.status);
    }

    export async function find(id: string): Promise<Response<ArticleWarehouse>> {
        const url = Config.get("FIND_ARTICLE_WAREHOUSE_URL", {id});
        const request = new Request(url)
        const response = await RestClient.get(request);
        if (response.success) {
            const t = response.data;
            if (t) {
                const articleWarehouse = new ArticleWarehouse(
                    t.id,
                    t.agencyId,
                    t.name,
                    t.createdAt,
                );
                return new Response<ArticleWarehouse>(true, articleWarehouse, response.error);
            }
        }
        return new Response<ArticleWarehouse>(true, undefined, response.error, response.status);
    }

    export async function create(articleWarehouse: ArticleWarehouse): Promise<Response<any>> {
        const url = Config.get("CREATE_ARTICLE_WAREHOUSE_URL");
        const request = new Request(url, articleWarehouse);
        return await RestClient.post(request);
    }

    export async function update(articleWarehouse: ArticleWarehouse): Promise<Response<any>> {
        const url = Config.get("UPDATE_ARTICLE_WAREHOUSE_URL", {id: articleWarehouse.id});
        const request = new Request(url, articleWarehouse);
        return await RestClient.put(request);
    }

     export async function transferArticle(fromId: string, transferArticleRequest: TransferArticleRequest): Promise<Response<any>> {
        const url = Config.get("TRANSFER_ARTICLE_FROM_WAREHOUSE_TO_DELIVERY_PERSON_URL", {id: fromId});
        const request = new Request(url, transferArticleRequest);
        return await RestClient.post(request);
    }

}